var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOversized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 15.5C15 17.2239 14.3152 18.8772 13.0962 20.0962C11.8772 21.3152 10.2239 22 8.5 22C6.77609 22 5.12279 21.3152 3.90381 20.0962C2.68482 18.8772 2 17.2239 2 15.5C2 13.7761 2.68482 12.1228 3.90381 10.9038C5.12279 9.68482 6.77609 9 8.5 9C10.2239 9 11.8772 9.68482 13.0962 10.9038C14.3152 12.1228 15 13.7761 15 15.5Z",
    fill: "#758295"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 8.5C22 11.76 19.6 14.45 16.48 14.92V14.86C16.17 10.98 13.02 7.83 9.11 7.52H9.08C9.31319 5.98422 10.0891 4.58287 11.2669 3.57013C12.4448 2.55739 13.9466 2.00034 15.5 2C16.3536 2 17.1988 2.16813 17.9874 2.49478C18.7761 2.82144 19.4926 3.30023 20.0962 3.90381C20.6998 4.50739 21.1786 5.22394 21.5052 6.01256C21.8319 6.80117 22 7.64641 22 8.5ZM5.59 2H3C2.45 2 2 2.45 2 3V5.59C2 6.48 3.08 6.93 3.71 6.3L6.3 3.71C6.92 3.08 6.48 2 5.59 2ZM18.41 22H21C21.55 22 22 21.55 22 21V18.41C22 17.52 20.92 17.07 20.29 17.7L17.7 20.29C17.08 20.92 17.52 22 18.41 22Z",
    fill: "#758295"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOversized);
export default __webpack_public_path__ + "static/media/oversized.10c8a8c9d580ef929cb5cc72cdc4a4e5.svg";
export { ForwardRef as ReactComponent };